import Device from '../device/Device';
import hubIcon from '../../images/hubIcon.svg';
import theme from '../../../../UI/theme';

const params = {
    fillColor: '#3C3C3C',
    size: 1.2,
    radius: 0.1,
    iconColor: theme.colors.darkSpace10,
    label: 'Hub',
    icon: hubIcon
}

class Hub extends Device {

    constructor(deviceInfo, layer) {
        super(deviceInfo, layer, params);
    }

    drawElementInGroup(point) {
        return this.drawIconElement(point);
    }
    
}

export default Hub;


